import { Skeleton } from "@material-ui/lab";
import Card from "../../../../../components/card";
import { Container, Row, Col } from "../style";

const Loading = () => {
  return (
    <>
      <Container>
        <Row className="row no-gutters">
          <Col className="col-6">
            <Card className="py-3 px-2 text-right mx-1">
              <Skeleton
                className="mx-auto transform-y-0"
                width={33}
                height={33}
                animation="wave"
              />
              <Skeleton
                className="mx-auto transform-y-0 mt-3"
                width={100}
                height={10}
                animation="wave"
              />
              <Skeleton
                className="mx-auto transform-y-0 mt-3"
                width={20}
                height={20}
                animation="wave"
              />
            </Card>
          </Col>
          <Col className="col-6">
            <Card className="py-3 px-2 text-right mx-1">
              <Skeleton
                className="mx-auto transform-y-0"
                width={33}
                height={33}
                animation="wave"
              />
              <Skeleton
                className="mx-auto transform-y-0 mt-3"
                width={100}
                height={10}
                animation="wave"
              />
              <Skeleton
                className="mx-auto transform-y-0 mt-3"
                width={20}
                height={20}
                animation="wave"
              />
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Loading;
